import request from "@/service";

/* 查询所有讲师列表 */
export function getBannerParamList(params) {
  return request({
    url: `/resource/pub/banner/page`,
    method: "post",
    data: params
  });
}

// 获取视频详情
export function getBannerInfo(data) {
  return request({
    url: `/resource/pub/banner/info/${data}`,
    method: "get"
  });
}

/* 新增 */
export function bannerSave(data) {
  return request({
    url: `/resource/pub/banner/save`,
    method: "post",
    data
  });
}

/* 修改 */
export function bannerEdit(data) {
  return request({
    url: `/resource/pub/banner/update`,
    method: "put",
    data
  });
}

/* 修改 */
export function bannerOnline(data) {
  return request({
    url: `/resource/pub/banner/online`,
    method: "put",
    data
  });
}

/* 删除 */
export function bannerDel(data) {
  return request({
    url: `/resource/pub/banner/delete`,
    method: "DELETE",
    data
  });
}

export function bannerDrag(data) {
  return request({
    url: `/resource/pub/banner/drag`,
    method: "post",
    data
  });
}


export function bannerShare(data) {
  return request({
    url: `/resource/pub/banner/saveShareList`,
    method: "post",
    data
  });
}

export function bannerCancelShare(data) {
  return request({
    url: `/resource/pub/banner/cancelShareList`,
    method: "post",
    data
  });
}

export function bannerRecover(data) {
  return request({
    url: `/resource/pub/banner/recoverShareList`,
    method: "post",
    data
  });
}

export function getBannerShareList(data) {
  return request({
    url: `/resource/pub/banner/shareList`,
    method: "post",
    data
  });
}





